import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const PrivacyPolicy: React.FC = () => {
  const { t } = useLanguage();

  return (
    <div className="privacy-policy">
      <div className="container">
        <h1>{t('privacy_policy_title')}</h1>
        <p>{t('privacy_policy_intro')}</p>

        {/* 1. 수집하는 개인정보 항목 */}
        <section>
          <h2>{t('privacy_policy_collect_title')}</h2>
          <p>{t('privacy_policy_collect_content')}</p>
          <ul>
            <li>{t('privacy_policy_collect_item_1')}</li>
            <li>{t('privacy_policy_collect_item_2')}</li>
            <li>{t('privacy_policy_collect_item_3')}</li>
            <li>{t('privacy_policy_collect_item_4')}</li>
          </ul>
        </section>

        {/* 2. 개인정보의 처리 목적 */}
        <section>
          <h2>{t('privacy_policy_section_1_title')}</h2>
          <p>{t('privacy_policy_section_1_content')}</p>
          <ul>
            <li>{t('privacy_policy_section_1_item_1')}</li>
            <li>{t('privacy_policy_section_1_item_2')}</li>
            <li>{t('privacy_policy_section_1_item_3')}</li>
            <li>{t('privacy_policy_section_1_item_4')}</li>
          </ul>
        </section>

        {/* 3. 개인정보의 처리 및 보유기간 */}
        <section>
          <h2>{t('privacy_policy_section_2_title')}</h2>
          <p>{t('privacy_policy_section_2_content')}</p>
          <ul>
            <li>{t('privacy_policy_section_2_item_1')}</li>
            <li>{t('privacy_policy_section_2_item_2')}</li>
            <li>{t('privacy_policy_section_2_item_3')}</li>
            <li>{t('privacy_policy_section_2_item_4')}</li>
          </ul>
        </section>

        {/* 4. 만 14세 미만 아동의 개인정보 처리 */}
        <section>
          <h2>{t('privacy_policy_children_title')}</h2>
          <p>{t('privacy_policy_children_content')}</p>
        </section>

        {/* 5. 개인정보의 제3자 제공 */}
        <section>
          <h2>{t('privacy_policy_section_3_title')}</h2>
          <p>{t('privacy_policy_section_3_content')}</p>
        </section>

        {/* 6. 개인정보 처리의 위탁 및 국외 이전 */}
        <section>
          <h2>{t('privacy_policy_consign_title')}</h2>
          <p>{t('privacy_policy_consign_content')}</p>
          <ul>
            <li>{t('privacy_policy_consign_item_1')}</li>
            <li>{t('privacy_policy_consign_item_2')}</li>
          </ul>
        </section>

        {/* 7. 정보주체와 법정대리인의 권리·의무 및 행사방법 */}
        <section>
          <h2>{t('privacy_policy_section_4_title')}</h2>
          <p>{t('privacy_policy_section_4_content')}</p>
          <ul>
            <li>{t('privacy_policy_section_4_item_1')}</li>
            <li>{t('privacy_policy_section_4_item_2')}</li>
            <li>{t('privacy_policy_section_4_item_3')}</li>
            <li>{t('privacy_policy_section_4_item_4')}</li>
          </ul>
        </section>

        {/* 8. 개인정보의 파기절차 및 방법 */}
        <section>
          <h2>{t('privacy_policy_destroy_title')}</h2>
          <p>{t('privacy_policy_destroy_content')}</p>
          <ul>
            <li>{t('privacy_policy_destroy_item_1')}</li>
            <li>{t('privacy_policy_destroy_item_2')}</li>
          </ul>
        </section>

        {/* 9. 개인정보의 안전성 확보조치 */}
        <section>
          <h2>{t('privacy_policy_section_5_title')}</h2>
          <p>{t('privacy_policy_section_5_content')}</p>
          <ul>
            <li>{t('privacy_policy_section_5_item_1')}</li>
            <li>{t('privacy_policy_section_5_item_2')}</li>
            <li>{t('privacy_policy_section_5_item_3')}</li>
            <li>{t('privacy_policy_section_5_item_4')}</li>
          </ul>
        </section>

        {/* 10. 개인정보 자동 수집 장치의 설치·운영 및 거부 */}
        <section>
          <h2>{t('privacy_policy_cookie_title')}</h2>
          <p>{t('privacy_policy_cookie_content')}</p>
        </section>

        {/* 11. 개인정보 보호책임자 */}
        <section>
          <h2>{t('privacy_policy_section_6_title')}</h2>
          <p>{t('privacy_policy_section_6_content')}</p>
          <div className="contact-info">
            <p><strong>{t('privacy_policy_officer')}</strong></p>
            <p>{t('privacy_policy_officer_name')}</p>
            <p>{t('privacy_policy_officer_phone')}</p>
            <p>{t('privacy_policy_officer_email')}</p>
          </div>
        </section>

        {/* 12. 정보주체의 권익침해 구제방법 */}
        <section>
          <h2>{t('privacy_policy_remedy_title')}</h2>
          <p>{t('privacy_policy_remedy_content')}</p>
          <ul>
            <li>{t('privacy_policy_remedy_item_1')}</li>
            <li>{t('privacy_policy_remedy_item_2')}</li>
            <li>{t('privacy_policy_remedy_item_3')}</li>
            <li>{t('privacy_policy_remedy_item_4')}</li>
          </ul>
        </section>

        {/* 13. 개인정보 처리방침의 변경 */}
        <section>
          <h2>{t('privacy_policy_section_7_title')}</h2>
          <p>{t('privacy_policy_section_7_content')}</p>
          <p className="effective-date">{t('privacy_policy_effective_date')}</p>
        </section>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
